<template>
  <div
    class="width-100"
    :class="[
      noMarginTop ? 'mt-0' : 'mt-0',
      { 'has-error': !!errorMessage, success: fieldMeta.valid },
    ]"
  >
    <InputGroup class="width-100">
      <Dropdown
        v-if="meta?.mode == 'edit'"
        :id="name"
        v-bind="inputAttrs"
        ref="dp"
        :name="name"
        :options="options"
        :option-label="optionLabel"
        :optionValue="optionValue"
        :option-group-label="optionGroupLabel"
        :option-group-children="optionGroupChildren"
        :placeholder="placeholder"
        :model-value="inputValue"
        :class="[className, { 'p-invalid': !!errorMessage }]"
        :filter="filterData"
        :disabled="disabled"
        class="base p-select-fluid"
        :loading="loading"
        @input="handleChange"
        @change="checkChange"
      >
        <!-- Slot forwarding -->
        <template v-for="(_, slot) in $slots" #[slot]="scope">
          <slot :name="slot" v-bind="scope" />
        </template>

        <template #header>
          <!-- <div class="text-center font-bold" v-if="inputAttrs">
            {{ inputAttrs.data }}
          </div> -->
        </template>
        <template #footer>
          <div v-if="btnCreate" class="flex justify-content-end mr-2 mb-1">
            <Button type="button" class="button-link" @click="onBtnRefresh">
              <Icon type="favicon" :icon="AppIcons.REFRESH2" class="text-left" />
            </Button>
            <Button type="button" class="button-link" @click="onBtnCreate">
              <Icon type="favicon" :icon="AppIcons.PLUS" class="text-left" />
              <span class="text-lg">Add {{ inputAttrs.name }}</span>
            </Button>
          </div>
        </template>
      </Dropdown>
      <div class="font-medium" v-else>
        {{ simplifiedValue }}
      </div>
      <InputGroupAddon
        v-if="
          addon &&
          inputValue != null &&
          inputValue > 0 &&
          disabled != true &&
          'edit' === meta.mode
        "
        v-tooltip.bottom="'Click here to edit'"
        @click="onBtnClick"
      >
        <i class="pi pi-pencil cursor-pointer" />
      </InputGroupAddon>
      <InputGroupAddon v-if="btnCreate1" @click="onBtnCreate">
        <i
          v-tooltip.bottom="'Click here to create'"
          class="pi pi-plus cursor-pointer"
        />
      </InputGroupAddon>
    </InputGroup>
    <small v-show="errorMessage" class="p-error font-normal block mt-1">
      {{ errorMessage }}
    </small>
  </div>
</template>
<script>
import { useField } from "vee-validate";
import { computed, watch } from "vue";
import { ref } from "vue";
import { AppIcons } from "../../../constants/app-icons";
export default {
  inject: ["meta"],
  props: {
    options: {
      type: [String, Array],
      default: "",
    },
    optionLabel: {
      type: String,
      default: "",
    },
    optionValue: {
      type: String,
      default: "",
    },
    optionGroupLabel: {
      type: String,
      default: "",
    },
    optionGroupChildren: {
      type: String,
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
    modelValue: {
      type: [String, Number],
      default: "",
    },
    className: {
      type: String,
      default: "",
    },
    emptyFilterMessage: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      required: true,
    },
    // filter: {
    //   type: Boolean,
    //   required: true,
    // },
    icon: {
      type: Boolean,
      default: true,
    },
    addon: {
      type: Boolean,
      default: true,
    },
    btnCreate: {
      type: Boolean,
      default: true,
    },
    btnCreate1: {
      type: Boolean,
      default: false,
    },

    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    inputAttrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    noMarginTop: Boolean,
  },
  setup(props, { emit }) {
    const dp = ref(null);
    const {
      value: inputValue,
      errorMessage,
      handleChange,
      meta: fieldMeta,
      resetField,
    } = useField(props.name, undefined, {
      initialValue: props.modelValue,
    });
    resetField({
      value: props.modelValue,
    });
    const filterData = computed(() => {
      let search = ref(false);
      if (props.options.length > 9) {
        search.value = true;
      }
      return search.value;
    });
    // empty checks...
    watch(
      () => props.options,
      (latest) => {
        if (latest.length <= 0) inputValue.value = null;
      },
    );

    // computed value for view mode
    // a computed ref
    const simplifiedValue = computed(() => {
      if (props.options) {
        let finderKey = props.optionValue || "id";
        let find = props.options.find(
          (value) => value[finderKey] == inputValue.value,
        );
        if (find) return find[props.optionLabel];
      }
      return "";
    });

    // model valule change events...
    watch(
      () => props.modelValue,
      (first) => {
        inputValue.value = props.modelValue;
      },
    );
    function checkChange(event) {
      //  event.preventDefault();

      emit("update:modelValue", event.value);
      emit("change", event);
      inputValue.value = event.value;

      emit("changeSSR", event);
    }
    function onBtnClick() {
      emit("btn-edit", { id: inputValue.value });
    }
    function onBtnCreate() {
      dp.value.hide();
      emit("btn-create");
    }
    function onBtnRefresh() {
      emit("btn-refresh");
    }

    return {
      dp,
      handleChange,
      errorMessage,
      inputValue,
      onBtnCreate,
      fieldMeta,
      checkChange,
      onBtnClick,
      filterData,
      onBtnRefresh,
      simplifiedValue,
    };
  },
  data() {
    return {
      AppIcons,
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
/* div.error .dropdown {
  background-color: var(--error-bg-color);
  color: var(--error-color);
}

div.error input:focus {
  border-color: var(--error-color);
} */

field .width-100.has-error :deep(.p-select) {
  border-color: var(--red-500);
}
.width-100.has-error :deep(.p-select:not(.p-disabled):hover) {
  border-color: var(--red-500);
}
.width-100.has-error :deep(.p-select:not(.p-disabled).p-focus) {
  border-color: var(--red-500);
  box-shadow: 0 0 0 0.2rem rgba(239, 68, 68, 0.25);
}

.Dropdown.success input {
  background-color: var(--success-bg-color);
  color: var(--success-color);
}

.Dropdown.success input:focus {
  border-color: var(--success-color);
}

.p-inputgroup {
  display: flex;
  align-items: stretch;
  width: 100%;

  > .p-select,
  > .p-select {
    flex: 1 1 auto;
    min-width: 0;
  }
}
.width-72 {
  width: 72% !important;
}
.base.p-inputgroup .inputtext,
.fluid .p-inputgroup .inputtext,
.p-inputgroup .inputwrapper,
.fluid .p-inputgroup .input {
  flex: 1 1 auto;
  width: 0% !important;
}
</style>
